import type { AdminLegacyRouteEntry, AdminRouteTarget } from './adminLegacyRouteManifest';

export type AppTarget = AdminRouteTarget | 'invalid';

export const normalizeAppTarget = (value: string): AppTarget => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'console' || normalized === 'admin') return normalized;
  return 'invalid';
};

export const getDefaultPathForTarget = (target: AppTarget): string => {
  if (target === 'admin') return '/system';
  if (target === 'console') return '/dashboard';
  return '/';
};

export const isRouteAllowedForTarget = (
  appTarget: AppTarget,
  routeTarget: AdminRouteTarget
): boolean => appTarget !== 'invalid' && appTarget === routeTarget;

export const getExposedRoutesForTarget = (
  appTarget: AppTarget,
  routes: AdminLegacyRouteEntry[]
): AdminLegacyRouteEntry[] => routes.filter((route) => isRouteAllowedForTarget(appTarget, route.target));

